export const parseTrimline = (trimline: string): string => {
  return trimline.toLowerCase().replace(/\s+/g, '_');
};
